/* Earthly Habit — PDP product form
   Variant picker, price updates, availability messaging. */

(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantInput = form.querySelector('input[name="id"]');
    const dataEl = form.querySelector('[data-product-data]');
    if (!dataEl) return;

    let product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (e) { return; }

    const variantPicker = form.querySelector('[data-variant-picker]');
    const priceEl = form.querySelector('[data-product-price]');
    const compareEl = form.querySelector('[data-product-compare]');
    const availabilityEl = form.querySelector('[data-product-availability]');
    const atcLabel = form.querySelector('[data-atc-label]');

    function selectedOptions() {
      const groups = variantPicker ? variantPicker.querySelectorAll('[data-variant-group]') : [];
      return [...groups].map((g) => {
        const active = g.querySelector('.variant-opt.is-active');
        return active ? active.dataset.value : null;
      });
    }

    function matchVariant() {
      const sel = selectedOptions();
      return product.variants.find((v) =>
        v.options.every((opt, i) => sel[i] == null || sel[i] === opt)
      );
    }

    function updateUI() {
      const variant = matchVariant();
      if (!variant) {
        availabilityEl && (availabilityEl.textContent = 'Unavailable');
        atcLabel && (atcLabel.textContent = 'Unavailable');
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (availabilityEl) availabilityEl.textContent = variant.available ? 'In stock' : 'Sold out';
      if (atcLabel) atcLabel.textContent = variant.available ? `Add to bag — ${formatMoney(variant.price)}` : 'Sold out';
    }

    document.addEventListener('variant:change', updateUI);
    updateUI();
  });

  function formatMoney(cents) {
    const fmt = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
})();
